<template>
  <section class="hot-vacancies  container">
    <div class="hot-vacancies__content  container-inner">
      <h2 class="hot-vacancies__title">{{ label ? label : $tHome('Hot vacancies') }}</h2>
      <div v-if="vacanciesComputed.length"
           :class="'_quantity-' + vacanciesComputed.length"
           class="hot-vacancies__list">
        <VacancyCardSmall v-for="(vacancy, index) in vacanciesComputed"
                          :vacancy="vacancy"
                          :key="vacancy.id"
                          @bookmark="setVacancyBookmark(index, $event)"
                          class="hot-vacancies__item"/>
      </div>
      <div v-else
           class="hot-vacancies__list">
        No vacancies
      </div>
      <HomePageSectionVacanciesBtn :text="$tHome('See all jobs')"
                                   class="hot-vacancies__btn"/>
    </div>
  </section>
</template>

<script>
  import HomePageSectionVacanciesBtn from './common/HomePageSectionVacanciesBtn'
  import VacancyCardSmall from '@/components/vacancyCardSmall/VacancyCardSmall'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import {WINDOW_SIZE_MD} from '@/constants/windowSizes'

  export default {
    name: 'HomePageHotVacancies',
    mixins: [windowSizeMixin],
    components: {
      HomePageSectionVacanciesBtn,
      VacancyCardSmall
    },
    props: {
      vacancies: {
        type: Array,
        required: true
      },
      label: {
        type: String
      }
    },
    data(vm) {
      return {
        vacanciesInner: JSON.parse(JSON.stringify(vm.vacancies))
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      vacanciesComputed() {
        return this.windowSizeMixin.width < WINDOW_SIZE_MD ? this.vacanciesInner.slice(0, 3) : this.vacanciesInner.slice(0, 4)
      }
    },
    methods: {
      setVacancyBookmark(index, value) {
        this.$set(this.vacanciesInner[index], 'in_bookmarks', value)
      }
    }
  }
</script>

<style lang="less">

</style>
